<ng-container *ngIf="designVersion !== 'v3'">
<div class="eyeicon-scroll-container" *ngIf="pagelist!='resume-requests'"
  infiniteScroll [infiniteScrollDistance]="5" [scrollWindow]="false" [infiniteScrollThrottle]="200"
  [alwaysCallback]="true" (scrolled)="onScrollResume()">
  <div class="col-sm-12 col-lg-12 col-md-12">
    <div class="row">

      <div class="col-md-12 padding-left-0 padding-right-5" *ngIf="resumeRequestedUserList | async as response">
        <app-candidate-job-details class="candidateJobContent" *ngIf="response?.length > 0"
          [interactionResponse]="response" [cardContent]="'RESUME_SENT'" [showInteractiveButton]="true"></app-candidate-job-details>
        <app-common-skeleton *ngIf="loadAPIcall && response?.length > 0" [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
      </div>
      <div class="col-sm-12 pl-1 end" *ngIf="resumeRequestedStopScroll && (resumeRequestedUserList | async)?.length > 0" style="text-align: center;padding-top: 1rem;">
        <div class="col-sm-12">
          <ng-icon name="tablerCircleCheck"></ng-icon>
        </div>
        <div class="col-sm-12">
          <p class="biase">You've reached the bottom of the page</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12" *ngIf="loadAPIcall && (resumeRequestedUserList | async)?.length == 0">
    <app-common-skeleton [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
  </div>
  <div class="col-12" *ngIf="!loadAPIcall && (resumeRequestedUserList | async)?.length == 0">
    <div class="gs-empty">
      <span class="gs-empty-icon"><ng-icon name="tablerFileText"></ng-icon></span>
      <div class="gs-empty-title">No resume requests sent</div>
      <div class="gs-empty-sub">Resume requests you send will show up here.</div>
    </div>
  </div>
</div>

<!-- Job-level disable: blocked / non-active job greys the whole Resume
     Requests listing and blocks pointer events. -->
<div *ngIf="pagelist === 'resume-requests'" class="sub-entities-scroll-container"
   [ngClass]="{'disabled': !jobDetails?.availability || jobDetails?.status !== 'ACTIVE'}"
   id="entity-container" infiniteScroll [infiniteScrollDistance]="5"
   [infiniteScrollThrottle]="200" [scrollWindow]="false"
   [alwaysCallback]="true"
   (scrolled)="onScrollDown()">
  <div class="col-md-12 padding-left-0 padding-right-5" *ngIf="loadAPIcall && passValues.length === 0">
    <app-common-skeleton [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
  </div>
  <div *ngIf="passValues.length > 0;else noResult">
    <div *ngFor="let item of passValues; let i = index;">
      <app-candidate-card
        [appliedJobDetails]="jobDetails"
        [viewSize]="'medium'"
        [resumerequsetuser]="item.user"
        [candidateval]="item">
      </app-candidate-card>
    </div>
    <app-common-skeleton *ngIf="loadAPIcall && !stopscrollFlag"
      [countforView]="10" [NameOftheScreen]="'jobcardlarge'">
    </app-common-skeleton>
    <div *ngIf="stopscrollFlag" class="caught_up">
      <div class="col-md-12">
        <ng-icon name="tablerCircleCheck"></ng-icon>
      </div>
      <div class="col-md-12">
        <p class="biase">You've reached the bottom of the page</p>
      </div>
    </div>
  </div>
  <ng-template #noResult>
    <div class="wert">
      <div class="col-md-12 mg-bt-9">
        <ng-icon name="tablerZoomQuestion" *ngIf="responseReceived"></ng-icon>
        <ng-icon name="tablerUserSearch" *ngIf="!responseReceived"></ng-icon>
      </div>
      <div class="col-md-12 fig">{{ Resumerequeststatus }}</div>
    </div>
  </ng-template>
</div>
</ng-container>

<ng-container *ngIf="designVersion === 'v3'">
  <!-- Infinite scroll delegated to the outer `.jc-v3-entity-details-body`
       container. Do NOT add `.sub-entities-scroll-container` here — that
       V2-only class globally sets `overflow-y: scroll` (_common.scss:2305)
       and makes this div its own scroll viewport, stealing wheel events
       from the outer container so `(scrolled)` never fires. -->
  <!-- Job-level disable: blocked / non-active job greys the candidate list
       and blocks pointer events — bound on app-candidate-card-table-view
       below (not this wrapper) so it no longer also dims the "No Resume
       Requests Yet" empty state below it, which has nothing to grey out or
       block clicks on. -->
  <div *ngIf="pagelist === 'resume-requests'"
     id="entity-container" infiniteScroll
     [infiniteScrollDistance]="5"
     [infiniteScrollThrottle]="200"
     [infiniteScrollContainer]="'.jc-v3-entity-details-body'"
     [fromRoot]="true"
     [alwaysCallback]="true"
     (scrolled)="onScrollDown()">

    <!-- Initial-load skeleton — parity with applicants / talent-pool /
         invited. Previously V3 showed a blank area until the first
         response arrived. -->
    <div class="col-12" *ngIf="loadAPIcall && passValues?.length === 0">
      <app-common-skeleton [countforView]="4" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
    </div>

    <app-candidate-card-table-view
      [ngClass]="{'disabled': !jobDetails?.availability || jobDetails?.status !== 'ACTIVE'}"
      [designVersion]="'v3'"
      [pageName]="'resume-requests'"
      [response]="passValues"
      [loadAPIcall]="loadAPIcall"
      [jobDetails]="jobDetails"
      [showTimeline]="false"
      [stopscrollFlag]="stopscrollFlag"
      (onDownloadResume)="downloadResume($event)"
      (onOpenDocuments)="openDocuments($event)"
      (onStatusUpdate)="updateStatus($event.status, $event.candidate)"
      (inviteClicked)="invite($event)">
    </app-candidate-card-table-view>

    <!-- Pagination skeleton — shown while loading additional pages. -->
    <div class="col-12" *ngIf="loadAPIcall && passValues?.length > 0">
      <app-common-skeleton [countforView]="2" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
    </div>
    <div *ngIf="!loadAPIcall && passValues.length === 0" class="jc-v3-empty-state">
      <svg width="200" height="180" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="90" r="80" fill="#F5F3FF"/>
        <rect x="54" y="40" width="72" height="90" rx="7" fill="#ffffff" stroke="#7C3AED" stroke-width="1.8"/>
        <path d="M114 40 L126 52 L114 52 Z" fill="#C4B5FD"/>
        <rect x="64" y="62" width="48" height="4" rx="2" fill="#DDD6FE"/>
        <rect x="64" y="72" width="40" height="4" rx="2" fill="#EDE9FE"/>
        <rect x="64" y="82" width="44" height="4" rx="2" fill="#EDE9FE"/>
        <rect x="64" y="92" width="36" height="4" rx="2" fill="#EDE9FE"/>
        <rect x="64" y="108" width="52" height="12" rx="4" fill="#EDE9FE" stroke="#7C3AED" stroke-width="1.2"/>
        <line x1="78" y1="114" x2="102" y2="114" stroke="#7C3AED" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="148" cy="128" r="18" fill="#7C3AED" opacity="0.10"/>
        <circle cx="148" cy="128" r="13" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
        <line x1="148" y1="122" x2="148" y2="128" stroke="#7C3AED" stroke-width="2" stroke-linecap="round"/>
        <circle cx="148" cy="131" r="1.5" fill="#7C3AED"/>
        <circle cx="50" cy="50" r="3" fill="#A78BFA"/>
        <circle cx="155" cy="55" r="2" fill="#C4B5FD"/>
      </svg>
      <h3>No Resume Requests Yet</h3>
      <p>Resume requests sent for this job will appear here.</p>
    </div>
  </div>
</ng-container>

<!-- Document Management — opens when V3 row's Documents icon fires
     `(onOpenDocuments)`. Same component / wiring as job-applicants. -->
<app-candidate-documents
  *ngIf="selectedCandidateForDocument"
  [pageName]="'candidate-card'"
  [isOpen]="showDocumentSection"
  [listOfDocuments]="typeOfDocuments"
  [candidateId]="selectedCandidateForDocument.candidateId"
  [jobId]="jobDetails.jobId"
  [count]="totalMandatoryDocuments"
  [allDocumentsVerified]="allVerified"
  (close)="closeDocuments()"
  (save)="saveDocuments($event)"
  (dataChanged)="refreshDocumentData()">
</app-candidate-documents>

<!-- Invite to Apply modal — nested job listing where the recruiter picks
     the job(s) to invite the candidate to. Same template as talent-pool /
     suggested-candidates-ai-list. -->
<ng-template #jobsupplytemplate>
  <app-new-job [focus]="focus" [screenName]="'invite-job-listing'" [filterData]="candidateData"></app-new-job>
</ng-template>
